import { Controller } from "@hotwired/stimulus";

window.pagefind = require("../pagefind.js");

export default class extends Controller {
  static targets = [
    "container",
    "empty",
    "placeholder",
    "searching",
    "label",
    "input",
    "form",
  ];
  static values = {
    q: String,
    indexed: {
      type: String,
      default: "indexed",
    },
  };

  async connect() {
    await window.pagefind.options({
      baseUrl: "",
      bundlePath: "pagefind/",
      excerptLength: 0,
    });

    await window.pagefind.init();
    this.filters = await window.pagefind.filters();

    if (window.location.search) {
      const searchParams = new URLSearchParams(window.location.search);

      if (searchParams.has("q")) {
        const form = this.formTarget;

        if ("q" in form.elements) {
          form.elements.q.value = searchParams.get("q");
          this.search({ target: form });
        }
      }
    }
  }

  async search(event) {
    if (!this.hasContainerTarget) return;

    const form = event.target;
    const formData = new FormData(form);

    const q = formData.get("q") || null;
    const filters = {};
    const sort = {};

    for (const key of formData.keys()) {
      if (key === "q") continue;
      if (key === "sort") {
        formData.getAll(key).forEach((x) => {
          const [sortBy, direction] = x.split("/");

          sort[sortBy] = direction || "asc";
        });
      } else if (!this.filters[key]) {
        console.error(
          `Search form contains an element not configured as Pagefind filter. Add the corresponding data-pagefind-filter to _layouts/default.html`,
          key,
        );
      } else {
        const any = formData.getAll(key).filter((x) => x);

        if (any.length !== 0) filters[key] = { any };
      }
    }

    this.qValue = q;
    this.formDisable(form, true);
    this.emptyTargets.forEach((x) => (x.hidden = true));
    this.searchingTargets.forEach((x) => (x.hidden = false));
    this.containerTarget.innerHTML = "";

    const searchResults = (await window.pagefind.search(q, { filters, sort }))
      .results;

    this.searchingTargets.forEach((x) => (x.hidden = true));

    if (searchResults.length) {
      if (sort["score"] === "asc") {
        this.renderResults(searchResults.reverse());
      } else {
        this.renderResults(searchResults);
      }
    } else {
      this.emptyTargets.forEach((x) => (x.hidden = false));
    }

    this.formDisable(form, false);
  }

  updateHistory() {
    const q = this.qValue;
    const query = new URLSearchParams({ q });

    window.history.pushState({ q }, q, `?${query.toString()}`);
  }

  formDisable(form, disable) {
    Array.from(form.elements).forEach((x) => (x.disabled = disable));
  }

  renderResults(results) {
    results.forEach((result) =>
      result.data().then((x) => this.renderResult(x)),
    );
  }

  renderResult(result) {
    if (!result.meta[this.indexedValue]) {
      console.error("Result is missing meta", this.indexedValue, result);
      return;
    }

    const placeholder =
      this.placeholderTarget.content.firstElementChild.cloneNode(true);

    placeholder.setAttribute("id", result.meta.uuid);
    placeholder.setAttribute("src", result.meta[this.indexedValue]);

    this.containerTarget.appendChild(placeholder);
  }
}
